import request from ".";

/**用户登录 */
function login(data){
  return request('/tryLogin.action', 'post', data)
}

/**退出登录 */
function logout(data){
  return request('/logout.action', 'post', data)
}

/**获取邮箱验证码(找回密码) */
function getEmailVerificationCode(data){
  return request('/user/pass/findPasswordEmail', 'post', data)
}

/**获取手机验证码(找回密码) */
function getMobileVerificationCode(data){
  return request('/user/pass/findPasswordPhone', 'post', data)
}

/**通过邮箱找回密码 */
function findPasswordBeEmail(data){
  return request('/user/pass/findPassword', 'post', data)
}

/**通过手机号码找回密码 */
function findPasswordBeMobile(data){
  return request('/user/pass/findPasswordP', 'post', data)
}

/**获取手机登录验证码 */
function getPhoneLoginCode(data){
  return request('/user/login/loginCode', 'post', data)
}

/**获取用户个人信息 */
function getUserinfo(data){
  return request('/user/userInfo', 'post', data)
}

/**修改个人信息 */
function changeUserInfo(data){
  return request('/user/changeUserInfo', 'post', data)
}

/**修改邮箱 */
function changeEmail(data){
  return request('/user/changeEmail', 'post', data)
}

/**修改密码 */
function changePassword(data){
  return request('/user/changePassword', 'post', data)
}

/**设置汇总日期 */
function setSummaryDate(data){
  return request('/user/default/config/setStockDate', 'post', data)
}

/**获取已设置的汇总日期 */
function getSummaryDate(data){
  return request('/user/default/config/getStockDate', 'post', data)
}

/**获取销售提成设置 */
function getSaleCommissionConfig(data){
  return request('/config-service/storeConfig/getSaleCommissionConfig', 'post', data)
}

export default {
  login, getEmailVerificationCode, getMobileVerificationCode,
  findPasswordBeEmail, findPasswordBeMobile, getPhoneLoginCode,
  getUserinfo, logout, changeUserInfo, changeEmail, changePassword,
  setSummaryDate, getSummaryDate, getSaleCommissionConfig
}
